module.exports = __webpack_public_path__ + "static/media/m15sj.0fd2979b.png";